import React, {useContext, useEffect, useState} from "react";
import { observer } from "mobx-react-lite";
import { Context } from "../../index";
import { heatMapData, nameShorter } from "../../utils/utils";
import { Chart } from "react-chartjs-2";
import {
    Chart as ChartJS,
    Tooltip,
    Legend,
    Title,
    LinearScale,
    CategoryScale,
} from "chart.js";
import { TreemapController, TreemapElement } from "chartjs-chart-treemap";

ChartJS.register(
    CategoryScale,
    LinearScale,
    Title,
    Legend,
    Tooltip,
    TreemapController,
    TreemapElement
);


const HeatMap = ({allMarks, days, today}) => {
    const {userStore} = useContext(Context);

    const [data, setData] = useState({});

    useEffect(() => {
        const newData = heatMapData(allMarks, days, new Date(today))
        setData(newData);
    }, [days, userStore.theme])

    return (
        <Chart
            className="heatmap"
            type="treemap"
            data={{
                datasets: [{
                    tree: Object.keys(data).map(s => ({ v: 1, name: s, change: data[s] })),
                    key: 'v',
                    groups: ['name'],
                    backgroundColor(ctx) {
                        const item = ctx.dataset.tree?.[ctx.index];
                        if (!item) return "gray"; // дефолтный цвет

                        const value = item.change ?? 0;
                        const clamped = Math.max(-1/3, Math.min(1/3, value)) * 3;

                        if (userStore.theme === "light") {
                            if (value === 0) {
                                return "rgb(160, 160, 160)";
                            } else if (value < 0) {
                                const lightness = 70 - Math.min(Math.abs(clamped) * 30, 30);
                                return `hsl(0, 100%, ${lightness}%)`;
                            } else {
                                const lightness = 45 - Math.min(clamped * 20, 20);
                                return `hsl(140, ${70+Math.min(Math.abs(clamped) * 40, 40)}%, ${lightness}%)`;
                            }
                        } else {
                            if (value === 0) {
                                return "rgb(160, 160, 160)";
                            } else if (value < 0) {
                                const lightness = 65 - Math.min(Math.abs(clamped) * 30, 30);
                                return `hsl(0, 100%, ${lightness}%)`;
                            } else {
                                const lightness = 45 - Math.min(clamped * 25, 25);
                                return `hsl(140, ${70+Math.min(Math.abs(clamped) * 40, 40)}%, ${lightness}%)`;
                            }
                        }
                    },

                    labels: {
                        display: true,
                        borderColor: "white",
                        borderWidth: 3,
                        formatter(ctx) {
                            const item = ctx.raw._data.children[0];
                            if (!item) return [""];

                            const rectWidth = ctx.raw.w || ctx.chart.getBoundingClientRect().width;

                            return [
                                nameShorter(item.name, rectWidth),
                                `${item.change > 0 ? '+' : ''}${item.change.toFixed(2)}`
                            ];
                        },
                        font: {
                            weight: 'bold'
                        },
                        color: 'white'
                    }
                }]
            }}
            options={{
                responsive: true,
                aspectRatio: 1,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            title(ctx) {
                                const node = ctx[0]?.raw?._data;
                                const item = node?.children?.[0] || node;
                                return item?.name || 'Предмет';
                            },
                            label(ctx) {
                                const node = ctx.raw?._data;
                                const item = node?.children?.[0] || node;
                                if (!item || typeof item.change !== 'number') return 'Н/Д';
                                const sign = item.change > 0 ? '+' : '';
                                return `Изменение среднего балла: ${sign}${item.change.toFixed(2)}`;
                            }
                        }
                    }
                }
            }}
        />
    );
};

export default observer(HeatMap);